import React, { useEffect, useState } from "react";
import Footer from "../../Components/Footer/footer";
import performRequest from "../../api/request";
import { Toast } from "../../CustomComponent/toast";
import LoadingPage from "../../Components/layouts/loading";
import getFilteredURL from "../../Components/Functions/filters.getUrl";
import Pagination from "../../Components/layouts/pagination";
import ReimbursementTable from "./Reimbursement/all_reimbursement_table";
import { BsReceiptCutoff } from "react-icons/bs";
import { FcCalculator } from "react-icons/fc";
import DynamicFilterInput from "../../Components/layouts/filter.inpit";
import DynamicFilterSelect from "../../Components/layouts/filter.select";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import { useLocation, useNavigate } from "react-router";

const ReimbursementManagement = () => {
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const pageFromURL = parseInt(queryParams.get("page")) || 1;
  const [page, setPage] = useState(pageFromURL);
  
  const [showPage, setShowPage] = useState(1);
  const [data, setData] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [filters, setFilters] = useState({
    startdate: "",
    enddate: "",
    generatedBy: "",
  });

  const [employee, setGeneratedBy] = useState();

  useEffect(() => {
    navigate(`?page=${page}`, { replace: true });
  }, [page, navigate]);


  useEffect(() => {
    if (location?.pathname && location?.pathname.includes(".csv")) {
      performRequest("GET", "/reimbursement/getReimbursementCSV")
        .then((res) => {
          if (res.status === 200) {
            const blob = new Blob([res.data], { type: "text/csv" });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "reimbursement.csv";
            a.click();
            window.URL.revokeObjectURL(url);
            navigate("/reimbursement-management");
          } else {
            Toast("error", "Error while downloading CSV!");
          }
        })
        .catch((err) => CustomErrorResponse(err));
      return;
    }
    performRequest("GET", "/leads/getAllLeadsOwners")
      .then((res) => setGeneratedBy(res?.data))
      .catch((err) => CustomErrorResponse(err));
  }, [location?.pathname]);
  
  useEffect(() => {
    performRequest("GET", "/leads/getAllLeadsOwners")
      .then((res) => setGeneratedBy(res?.data))
      .catch((err) => CustomErrorResponse(err));
  }, []);

  useEffect(() => {
    setLoading(true);
    performRequest(
      "GET",
      getFilteredURL("/reimbursement/getReimbursement/", page, filters)
    )
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
          setTotalPages(Math.ceil(res.data.reimbursementCount / 50));
        } else {
          Toast("error", "Error while getting POCDPI!");
        }
      })
      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [page, refresh]);

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none">
            <div className="row align-items-center mb-3">
              <div className="col-md-8">
                <h2 className="page-title mb-1">
                  <FcCalculator className="fs-2  me-1" /> Reimbursement
                  Management
                </h2>
                <h4 className="text-muted">
                  {/* <StepRoutes /> */} Request reimbursements.
                </h4>
              </div>
              <div className="col-md-4">
                <div className="btn-list justify-content-end">
                  <a href={"/reimbursement-management/new"}>
                    <button className="btn btn-primary d-none d-sm-block">
                      <BsReceiptCutoff className="me-2 fs-2" /> ADD NEW
                      REIMBURSEMENT
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-3 col-sm-12 py-2">
              <div className="card p-2">
                <div
                  id="faq-1"
                  className="accordion"
                  role="tablist"
                  aria-multiselectable="true"
                >
                  <div>
                    <div className="accordion-header m-0" role="tab">
                      <button
                        className="accordion-button fs-3 d-md-none p-0"
                        data-bs-toggle="collapse"
                        data-bs-target="#faq-1-1"
                      >
                        <h3 className="m-0">Filter result</h3>
                      </button>
                    </div>

                    <div
                      id="faq-1-1"
                      className="accordion-collapse collapse d-md-none"
                      role="tabpanel"
                      data-bs-parent="#faq-1"
                    >
                      <div className="accordion-body pt-0">
                        <div className="row">
                          <div className="col-12">
                            <DynamicFilterInput
                              label="Start Date:"
                              value={filters.startdate}
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  startdate: e.target.value,
                                })
                              }
                              type="date"
                            />
                          </div>
                          <div className="col-12">
                            <DynamicFilterInput
                              label="End Date:"
                              value={filters.enddate}
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  enddate: e.target.value,
                                })
                              }
                              type="date"
                            />
                          </div>
                          <div className="col-12">
                            <DynamicFilterSelect
                              label="generated By:"
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  generatedBy: e.target.value,
                                })
                              }
                              value={filters.generatedBy}
                            >
                              <option value="">select all</option>

                              {employee &&
                                employee?.map((employee, index) => {
                                  return (
                                    <option
                                      key={index}
                                      value={employee.userName}
                                    >
                                      {employee.userName}
                                    </option>
                                  );
                                })}
                            </DynamicFilterSelect>
                          </div>

                          <div className="col-12">
                            <div className="row mt-2">
                              <div className="col-6">
                                <button
                                  onClick={() => setRefresh(!refresh)}
                                  className="btn btn-success w-100"
                                >
                                  Apply Filter
                                </button>
                              </div>
                              <div className="col-6">
                                <button
                                  onClick={() => {
                                    setFilters({
                                      startdate: "",
                                      enddate: "",
                                      generatedBy: "",
                                    });
                                    setRefresh(!refresh);
                                  }}
                                  className="btn btn-secondary w-100"
                                >
                                  Reset Filter
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="card p-3 mt-1">
                        <h3>Reimbursement Policy</h3>
                        <p>
                          For claims above ₹2,000: The reimbursement amount will
                          be processed within 2–3 working days from the date of
                          approval.
                        </p>
                        <p>
                          For claims below ₹2,000: The reimbursement amount will
                          be processed within 6–8 working days from the date of
                          approval.
                        </p>
                        <p>
                          However, prior intimation is mandatory. Employees must
                          inform why the expense is required and who will be
                          making the payment before spending.
                        </p>
                        <p>
                          Claims should be submitted through CRM only i.e
                          Alpha.Kryzen
                        </p>
                        <p>
                          Claims without adequate documentation or prior
                          intimation may be subject to rejection or adjustment
                          as per company policy.
                        </p>
                      </div>
                    </div>

                    <div className="accordion-body d-none d-md-block">
                      <div className="row">
                        <h3>Filter result</h3>
                        <div className="col-12">
                          <DynamicFilterInput
                            label="Start Date:"
                            value={filters.startdate}
                            onChange={(e) =>
                              setFilters({
                                ...filters,
                                startdate: e.target.value,
                              })
                            }
                            type="date"
                          />
                        </div>
                        <div className="col-12">
                          <DynamicFilterInput
                            label="End Date:"
                            value={filters.enddate}
                            onChange={(e) =>
                              setFilters({
                                ...filters,
                                enddate: e.target.value,
                              })
                            }
                            type="date"
                          />
                        </div>
                        <div className="col-12">
                          <DynamicFilterSelect
                            label="generated By:"
                            onChange={(e) =>
                              setFilters({
                                ...filters,
                                generatedBy: e.target.value,
                              })
                            }
                            value={filters.generatedBy}
                          >
                            <option value="">select all</option>

                            {employee &&
                              employee?.map((employee, index) => {
                                return (
                                  <option key={index} value={employee.userName}>
                                    {employee.userName}
                                  </option>
                                );
                              })}
                          </DynamicFilterSelect>
                        </div>

                        <div className="col-12">
                          <div className="row mt-2">
                            <div className="col-6">
                              <button
                                onClick={() => setRefresh(!refresh)}
                                className="btn btn-success w-100"
                              >
                                Apply Filter
                              </button>
                            </div>
                            <div className="col-6">
                              <button
                                onClick={() => {
                                  setFilters({
                                    startdate: "",
                                    enddate: "",
                                    generatedBy: "",
                                  });
                                  setRefresh(!refresh);
                                }}
                                className="btn btn-secondary w-100"
                              >
                                Reset Filter
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card p-3 mt-1 fs-4">
                <h3>Reimbursement Policy</h3>
                <p>
                  For claims above ₹2,000: The reimbursement amount will be
                  processed within 2–3 working days from the date of approval.
                </p>
                <p>
                  For claims below ₹2,000: The reimbursement amount will be
                  processed within 6–8 working days from the date of approval.
                </p>
                <p>
                  Claims should be submitted through CRM only i.e Alpha.Kryzen
                </p>
                <p>
                  Claims without adequate documentation or prior intimation may
                  be subject to rejection or adjustment as per company policy.
                </p>
                <button
                  className="btn btn-primary"
                  data-bs-toggle="modal"
                  data-bs-target="#modal-report-2"
                >
                  Read More
                </button>
              </div>
            </div>

            <div className="col-md-9 col-sm-12 py-2">
              <div className="card">
                {data && data?.reimbursement && (
                  <ReimbursementTable
                    reimbursement={data?.reimbursement}
                    currentPage={page}
                    itemsPerPage={50}
                  />
                )}

                <div className="btn-list justify-content-center">
                  <a href={"/reimbursement-management/new"}>
                    <button className="btn btn-primary d-lg-none d-md-none mt-3 mb-3">
                      <BsReceiptCutoff className="me-2 fs-2" /> ADD NEW
                      REIMBURSEMENT
                    </button>
                  </a>
                </div>

                <Pagination
                  page={page}
                  setPage={setPage}
                  totalPages={totalPages}
                  pageDatalength={data?.reimbursement?.length}
                  showPage={showPage}
                  setShowPage={setShowPage}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Modal */}
        <div
          className="modal fade"
          id="modal-report-2"
          tabIndex="-1"
          role="dialog"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-md modal-md-width" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title"> Reimbursement Policy</h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>

              <div className="modal-body">
                <div class="reimbursement-policy">
                  <div class="policy-title">
                    <h2>Reimbursement Policy</h2>
                  </div>

                  <div class="policy-points">
                    <ul>
                      <li>
                        For claims above ₹2,000: The reimbursement amount will
                        be processed within 2–3 working days from the date of
                        approval.
                      </li>

                      <li>
                        For claims below ₹2,000: The reimbursement amount will
                        be processed within 7–8 working days from the date of
                        approval.
                      </li>

                      <li>
                        Reimbursement for any pay done for office work will be
                        considered, Only expenses like the travel, client
                        meetings, office purchases, etc. can be reimbursed.
                      </li>

                      <li>
                        All employees are eligible to apply for reimbursement.
                      </li>

                      <li>
                        However, prior intimation is mandatory. Employees must
                        inform why the expense is required and who will be
                        making the payment before spending.
                      </li>

                      <li>
                        Claims without prior approval will not be processed.
                      </li>

                      <li>
                        Employees must submit claims on the same day i.e on the
                        date of expenses made.
                      </li>

                      <li>Late submissions may require extra approval.</li>

                      <li>
                        Claims should be submitted through CRM only i.e
                        Alpha.Kryzen
                      </li>

                      <li>All documents must be clear and readable.</li>
                    </ul>
                  </div>

                  <div class="policy-section">
                    <p>
                      <strong>Non-Reimbursable Items-</strong>
                    </p>
                    <ul>
                      <li>Personal expenses</li>
                      <li>Snacks/food unless work-related</li>
                      <li>Unapproved purchases</li>
                      <li>Fuel claims without log or travel reason</li>
                    </ul>
                  </div>

                  <div class="policy-points">
                    <ul>
                      <li>
                        Verifications for the reimbursement can be done by
                        Accounts or HR teams.
                      </li>

                      <li>
                        Any mismatch or manipulated document will result in
                        rejection and possible disciplinary action.
                      </li>

                      <li>
                        Payments will be processed via bank transfer / salary
                        account.
                      </li>

                      <li>
                        Employees will be informed once reimbursement is
                        completed.
                      </li>

                      <li>
                        Employees must fill all mandatory fields (date, purpose,
                        amount, vendor).
                      </li>

                      <li>
                        Duplicate bills or unclear photocopies will not be
                        accepted.
                      </li>

                      <li>
                        If cash is used, a proper cash receipt must be attached
                        with vendor details.
                      </li>

                      <li>
                        For employees traveling or purchasing in foreign
                        currency, reimbursement will be processed based on the
                        exchange rate of that day.
                      </li>

                      <li>
                        If an employee seeks reimbursement for fuel expenses,
                        they must submit photographic proof clearly showing the
                        fuel level before travel and the fuel level upon
                        reaching the destination.
                      </li>

                      <li>
                        Reimbursement shall be calculated only for the actual
                        fuel consumed during official travel based on this
                        submitted proof.
                      </li>
                    </ul>
                  </div>

                  <div class="policy-section">
                    <p>
                      In cases where relevant or valid proof (as mentioned
                      above) is not submitted, fuel reimbursement will be
                      processed on a standard per-kilometer basis as follows:
                    </p>

                    <ul>
                      <li>Petrol Car: ₹7 per km</li>
                      <li>Bike: ₹3 per km</li>
                    </ul>

                    <p>
                      These rates shall be considered final and non-negotiable.
                      <br></br>
                      Meal expenses will be supported by the company up to ₹150
                      per meal.
                    </p>
                  </div>

                  <div class="policy-points">
                    <ul>
                      <li>
                        Claims without adequate documentation or prior
                        intimation may be subject to rejection or adjustment as
                        per company policy.
                      </li>

                      <li>
                        For any expense paid through bank transfer, UPI, or
                        online payment, employees must submit valid documentary
                        proof clearly showing that the payment was made to the
                        specific business/vendor and/or individual concerned.
                      </li>

                      <li>
                        Merely providing bank account numbers or transaction
                        references without identifiable payee details will not
                        be accepted as valid proof.
                      </li>

                      <li>
                        Employees are required to capture and retain a
                        screenshot or acknowledgment of the successful payment
                        at the time of transaction, clearly reflecting the payee
                        name, amount, and date, and submit the same along with
                        the reimbursement claim.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                <button className="btn btn-secondary" data-bs-dismiss="modal">
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default ReimbursementManagement;
